export default __webpack_public_path__ + "static/logo-1ba2985d27085177ea657f0642791d3e.png";